<template>
  <div>
    <custom-actions>
      <template #header>

        <el-button type="primary" v-if="hasAdd" @click="$router.push('/rawMaterialSupplier/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="materialsName" label="供应商名称">
          <el-input clearable v-model="searchForm.materialsName" placeholder="请输入供应商名称" />

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="供应商名称" prop="materialsName"></el-table-column>

        <el-table-column show-overflow-tooltip min-width="120" label="供应商地址" prop="materialsDz">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="联系方式" prop="contactNumber"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/rawMaterialSupplier/detail?materialsId=' + row.materialsId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/rawMaterialSupplier/edit?materialsId=' + row.materialsId)">编辑</el-button>

            <el-button type="text" v-if="hasDel" @click="deleteRow(row.materialsId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'rawMaterialSupplier',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        materialsName: null

      }

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }

  },

  created() {
    this.loadData()
  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1

      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        materialsName: null
      }

      this.onSearch()
    },
    deleteRow(materialsId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.rawMaterialSupplier.deletePaRawMaterials, {
          materialsId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 600;
  margin-bottom: 10px;

  .color {
    color: #007bff;
    line-height: normal;
    transform: translateY(2px);

  }

}
</style>
